module.exports = __webpack_public_path__ + "img/Cover7_small.db387aa9.png";